import type { ConversationSummaryInfoSummary } from 'lib-shared-types-api';
import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { hasFeature } from '../../shared/featureFlag';
import { actions } from '../actions/conversation';
import { originalEmailActions } from '../actions/originalEmail';
import MessageSection from '../components/messageSection';

const {
  originalEmailGet,
  originalEmailHtmlGetByType,
  originalEmailGetPrinterFriendly,
  originalEmailGetHtmlMessage,
} = originalEmailActions;

const mapStateToProps = (state) => {
  const metaConversation = state.conversation.metaConversation;
  const csid = metaConversation.conversation
    ? metaConversation.conversation.id
    : null;

  return {
    htmlMessages: state.emailMessages.messages.filter((m) => m.csid === csid),
    metaConversation: metaConversation,
    messages: metaConversation.messages,
    asyncStatus: state.conversation.asyncStatus,
    typings: state.typing.typings,
    thisUserId: state.settings.profile.profile.id,
    originalEmailMeta: state.originalEmail.meta,
    enableCallRecordings: hasFeature(state, 'enable-call-recordings'),
    useShadowDom: hasFeature(state, 'shadow-dom-messages'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    originalEmailGet: bindActionToPromise(dispatch, originalEmailGet),
    originalEmailHtmlGetByType: bindActionToPromise(
      dispatch,
      originalEmailHtmlGetByType,
    ),
    originalEmailGetHtmlMessage: bindActionToPromise(
      dispatch,
      originalEmailGetHtmlMessage,
    ),
    originalEmailGetPrinterFriendly: bindActionToPromise(
      dispatch,
      originalEmailGetPrinterFriendly,
    ),
    conversationClose: bindActionToPromise(dispatch, actions.conversationClose),
    conversationGet: bindActionToPromise(dispatch, actions.conversationGet),
    conversationSetSummary(payload: null | ConversationSummaryInfoSummary) {
      return dispatch(actions.conversationSetSummary(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageSection);
